import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-gray-300 py-3 m-3 border-l-4 border-blue-primary px-5 bg-black-footer"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Welcome Aboard, Let's start with editing your public profile. ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Edit Public Profile ")
const _hoisted_4 = {
  key: 1,
  class: "text-gray-300 py-3 m-3 border-l-4 border-blue-primary px-5 bg-black-footer"
}
const _hoisted_5 = { class: "mb-5" }
const _hoisted_6 = { class: "text-gray-text list-inside" }
const _hoisted_7 = { class: "inline-block mt-3" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("1. ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Sirius mobile wallet ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ul", { class: "list-outside list-square ml-9" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Download Sirius Testnet mobile wallet and create your account"),
  /*#__PURE__*/_createElementVNode("li", null, "Connect it with Developers Dashboard")
], -1)
const _hoisted_11 = { class: "inline-block mt-3" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("2. ")
const _hoisted_13 = {
  class: "hover:text-gray-300 duration-200 transition-all",
  href: "https://bctestnetwallet.xpxsirius.io/",
  target: "_blank"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Sirius testnet web wallet ")
const _hoisted_15 = { class: "list-outside list-square ml-9" }
const _hoisted_16 = {
  class: "hover:text-gray-300 duration-200 transition-all",
  href: "https://developers.xarcade.io/docs/Onboarding/TestnetWalletSetup/web_wallet_setup",
  target: "_blank"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Import your account from mobile wallet to web wallet ")
const _hoisted_18 = {
  class: "hover:text-gray-300 duration-200 transition-all",
  href: "https://developers.xarcade.io/docs/Onboarding/testnet_namespace",
  target: "_blank"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Create a game ")
const _hoisted_20 = {
  class: "hover:text-gray-300 duration-200 transition-all",
  href: "https://developers.xarcade.io/docs/Onboarding/testnet_token_creation%20copy",
  target: "_blank"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Create game token ")
const _hoisted_22 = {
  class: "hover:text-gray-300 duration-200 transition-all",
  href: "https://developers.xarcade.io/docs/Onboarding/link_token_to_game",
  target: "_blank"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Link a Token to your Game ")
const _hoisted_24 = { class: "mt-5" }
const _hoisted_25 = {
  class: "nav nav-tabs ml-3",
  id: "nav-tab"
}
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-test-net mr-2\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span></span>", 1)
const _hoisted_28 = { class: "flex items-center" }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-main-net mr-2\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span></span>", 1)
const _hoisted_30 = { class: "bg-black-footer p-4 m-3 mt-0" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h5", { class: "text-white mb-4" }, "Games", -1)
const _hoisted_32 = {
  class: "bg-black-primary",
  id: "nav-tabContent"
}
const _hoisted_33 = { class: "text-white overflow-auto p-3" }
const _hoisted_34 = {
  key: 0,
  class: "items-center flex"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-3 w-3 mr-3 bg-yellow-500 inline-block",
  viewBox: "0 0 24 24"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-sm" }, "Loading...", -1)
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = {
  key: 1,
  class: "table-dark w-full",
  id: "gamesList"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "Namespace"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "Current Version"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "Last Update"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "Game Status")
  ])
], -1)
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = { class: "small" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = { class: "small" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = { class: "small" }
const _hoisted_47 = {
  key: 0,
  class: "badge-red"
}
const _hoisted_48 = {
  key: 1,
  class: "badge-blue"
}
const _hoisted_49 = {
  key: 2,
  class: "badge-blue"
}
const _hoisted_50 = {
  key: 3,
  class: "badge-yellow"
}
const _hoisted_51 = {
  key: 4,
  class: "badge-gray"
}
const _hoisted_52 = {
  key: 2,
  class: "text-gray-text my-2"
}
const _hoisted_53 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_54 = /*#__PURE__*/_createTextVNode("View all Games")
const _hoisted_55 = { class: "bg-black-footer p-4 m-3" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h5", { class: "text-white my-4" }, "Tokens", -1)
const _hoisted_57 = { class: "overflow-auto" }
const _hoisted_58 = {
  key: 0,
  class: "items-center flex"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-3 w-3 mr-3 bg-yellow-500 inline-block",
  viewBox: "0 0 24 24"
}, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-sm" }, "Loading...", -1)
const _hoisted_61 = [
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = {
  key: 1,
  class: "table-dark w-full",
  id: "tokensList"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "Asset ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "Circulating Supply"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "Current Balance"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "Games")
  ])
], -1)
const _hoisted_64 = { class: "text-white" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_67 = { class: "small" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "xr-test-net" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
    /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
    /*#__PURE__*/_createElementVNode("span", { class: "path3" }),
    /*#__PURE__*/_createElementVNode("span", { class: "path4" })
  ])
], -1)
const _hoisted_69 = {
  key: 2,
  class: "text-gray-text my-2"
}
const _hoisted_70 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_71 = /*#__PURE__*/_createTextVNode("View all Tokens")
const _hoisted_72 = { class: "lg:grid lg:grid-cols-2 xl:grid-cols-3" }
const _hoisted_73 = { class: "xl:col-span-2 px-3 lg:pr-1.5 mb-3" }
const _hoisted_74 = { class: "p-4 bg-black-footer h-full" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("h5", { class: "text-white my-3" }, "Latest Transactions", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("hr", { class: "border-black-border border-t mb-3" }, null, -1)
const _hoisted_77 = { class: "overflow-auto" }
const _hoisted_78 = {
  class: "table-dark w-full",
  id: "txnList"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "In / Out"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "TX Hash"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "TimeStamp"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-title" }, "Asset")
  ])
], -1)
const _hoisted_80 = { class: "text-white" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { style: {"width":"80px"} }
const _hoisted_83 = {
  class: "truncate",
  style: {"max-width":"170px"}
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_85 = {
  key: 0,
  class: "text-gray-text mt-5"
}
const _hoisted_86 = { class: "px-3 lg:pl-1.5 mb-3" }
const _hoisted_87 = { class: "p-4 bg-black-footer" }
const _hoisted_88 = /*#__PURE__*/_createStaticVNode("<h5 class=\"text-white my-3\">Quick Links</h5><hr class=\"border-black-border border-t mb-2\"><div class=\"grid grid-cols-4 my-3 mt-4\"><div class=\"px-2 text-center\"><img src=\"./assets/images/icon-game1.png\" class=\"w-14 inline-block mt-2\"></div><div class=\"col-span-3\"><h6 class=\"card-title text-white\">What is XAR?</h6><p class=\"text-gray-text pb-3\">XAR is the native stable value token of Xarcade which is priced at approximately 1.125 USDT.</p></div></div>", 3)
const _hoisted_91 = { class: "grid grid-cols-4 mb-3" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "px-2 text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "./assets/images/icon-xar.png",
    class: "w-14 inline-block mt-2"
  })
], -1)
const _hoisted_93 = { class: "col-span-3" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("h6", { class: "card-title text-white" }, "What is Xarcade?", -1)
const _hoisted_95 = { class: "text-gray-text" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("Xarcade is a next-generation video game tokenization and distribution platform.")
const _hoisted_97 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_98 = {
  key: 0,
  class: "text-gray-text my-3 px-2",
  id: "readMore_div"
}
const _hoisted_99 = { class: "grid grid-cols-4" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "px-2 text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "./assets/images/icon-user1.png",
    class: "w-14 inline-block mt-2"
  })
], -1)
const _hoisted_101 = { class: "col-span-3" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("h6", { class: "card-title text-white" }, "Gamer's Perk?", -1)
const _hoisted_103 = { class: "item-faq" }
const _hoisted_104 = { class: "text-gray-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("main", null, [
    (_ctx.profileSetup === '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_router_link, {
            type: "button",
            class: "text-blue-primary underline",
            to: {name: 'viewAccount'}
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.walletSetup === '' && !_ctx.isCloseWalletOnBoard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, "Create Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet", 1),
          _createElementVNode("div", null, "Both Sirius " + _toDisplayString(_ctx.testnetLabel) + " mobile and web wallets are required in this process", 1),
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _hoisted_8,
                  _createVNode(_component_router_link, {
                    to: { name: 'viewHomeSettings' },
                    class: "hover:text-gray-300 duration-200 transition-all"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-arrow-up-right-from-square",
                        class: "ml-1"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_10
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _hoisted_12,
                  _createElementVNode("a", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-arrow-up-right-from-square",
                      class: "ml-1"
                    })
                  ])
                ]),
                _createElementVNode("ul", _hoisted_15, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-arrow-up-right-from-square",
                        class: "ml-1"
                      })
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-arrow-up-right-from-square",
                        class: "ml-1"
                      })
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-arrow-up-right-from-square",
                        class: "ml-1"
                      })
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-arrow-up-right-from-square",
                        class: "ml-1"
                      })
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("a", {
              href: "#",
              class: "text-blue-primary underline",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.checkWalletSetup && _ctx.checkWalletSetup(...args)), ["prevent"]))
            }, " I've setup Sirius " + _toDisplayString(_ctx.testnetLabel) + " account ", 1),
            _createElementVNode("a", {
              href: "#",
              class: "text-gray-text ml-2 underline",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.tempCloseWalletSetupOnboard && _ctx.tempCloseWalletSetupOnboard(...args)), ["prevent"]))
            }, "Later")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("nav", null, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("button", {
          class: _normalizeClass(["text-gray-text active py-2 px-4", _ctx.currentTab=='testnet'?'bg-black-footer':'cursor-pointer']),
          id: "nav-details-tab",
          onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.currentTab = 'testnet'; _ctx.loadData()})
        }, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("span", null, _toDisplayString(_ctx.testnetLabel), 1)
          ])
        ], 2),
        (_ctx.userData.mainnetWalletAddress)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["text-gray-text active py-2 px-4 ml-2", _ctx.currentTab=='mainnet'?'bg-black-footer':'cursor-pointer']),
              id: "nav-details-tab",
              onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.currentTab = 'mainnet'; _ctx.loadData()})
            }, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("span", null, _toDisplayString(_ctx.mainnetLabel), 1)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          (_ctx.showLoader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_37))
            : _createCommentVNode("", true),
          (!_ctx.showLoader)
            ? (_openBlock(), _createElementBlock("table", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: game.gameId,
                      onClick: ($event: any) => (_ctx.routeEditGame(game.gameId))
                    }, [
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(game.title ? game.title : "-"), 1),
                        _hoisted_41,
                        _createElementVNode("span", _hoisted_42, " ID: " + _toDisplayString(game.gameId), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(game.name), 1),
                        _hoisted_43,
                        _createElementVNode("span", _hoisted_44, " Expires on: " + _toDisplayString(game.newExpiry), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(game.version ? game.version : "-"), 1),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(game.updatedDate), 1),
                        _hoisted_45,
                        _createElementVNode("span", _hoisted_46, _toDisplayString(game.updatedTime), 1)
                      ]),
                      _createElementVNode("td", null, [
                        (game.status === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Rejected"))
                          : _createCommentVNode("", true),
                        (game.status === 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Active"))
                          : _createCommentVNode("", true),
                        (game.status === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Approved"))
                          : _createCommentVNode("", true),
                        (game.status === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Pending"))
                          : _createCommentVNode("", true),
                        (game.status === 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_51, "Game not submitted"))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_40))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.games.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, "No games available"))
            : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createVNode(_component_router_link, {
                  to: {name: 'viewGamesList'},
                  class: "text-yellow-bar text-sm hover:underline"
                }, {
                  default: _withCtx(() => [
                    _hoisted_54
                  ]),
                  _: 1
                })
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _hoisted_56,
      _createElementVNode("div", _hoisted_57, [
        (_ctx.showLoader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_61))
          : _createCommentVNode("", true),
        (!_ctx.showLoader)
          ? (_openBlock(), _createElementBlock("table", _hoisted_62, [
              _hoisted_63,
              _createElementVNode("tbody", _hoisted_64, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: token.tokenId,
                    onClick: ($event: any) => (_ctx.routeEditToken(token.tokenId))
                  }, [
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(token.symbol ? token.symbol : "-"), 1),
                      _hoisted_66,
                      _createElementVNode("span", _hoisted_67, _toDisplayString(token.title?token.title:token.description), 1)
                    ]),
                    _hoisted_68,
                    _createElementVNode("td", null, _toDisplayString(token.tokenId), 1),
                    _createElementVNode("td", null, _toDisplayString(token.supply), 1),
                    _createElementVNode("td", null, _toDisplayString(token.amount), 1),
                    _createElementVNode("td", null, _toDisplayString(token.names[0] ? token.names[0] : "-"), 1)
                  ], 8, _hoisted_65))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tokens.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_69, "No tokens available"))
          : (_openBlock(), _createElementBlock("div", _hoisted_70, [
              _createVNode(_component_router_link, {
                to: {name: 'viewTokensList'},
                class: "text-yellow-bar text-sm hover:underline"
              }, {
                default: _withCtx(() => [
                  _hoisted_71
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_72, [
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _hoisted_75,
          _hoisted_76,
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("table", _hoisted_78, [
              _hoisted_79,
              _createElementVNode("tbody", _hoisted_80, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (transaction) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: transaction.hash,
                    onClick: ($event: any) => (_ctx.goToExplorer(transaction.hash))
                  }, [
                    _createElementVNode("td", _hoisted_82, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-arrow-circle-up",
                        class: "icon-in text-success-check",
                        "aria-hidden": "true"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_83, _toDisplayString(transaction.hash), 1),
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(transaction.newDateFormat), 1),
                      _hoisted_84,
                      _createTextVNode(_toDisplayString(transaction.newTimeFormat), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(transaction.newType), 1),
                    _createElementVNode("td", null, _toDisplayString(transaction.amount ? transaction.amount : "-"), 1),
                    _createElementVNode("td", null, _toDisplayString(transaction.assetId ? transaction.assetId : "-"), 1)
                  ], 8, _hoisted_81))
                }), 128))
              ])
            ]),
            (_ctx.transactions.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_85, "No transaction available"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _hoisted_88,
          _createElementVNode("div", _hoisted_91, [
            _hoisted_92,
            _createElementVNode("div", _hoisted_93, [
              _hoisted_94,
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_95, [
                  _hoisted_96,
                  _hoisted_97,
                  _createElementVNode("a", {
                    class: "text-blue-primary",
                    id: "readMore",
                    href: "#",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => {_ctx.isAboutDropDown = !_ctx.isAboutDropDown;}, ["prevent"]))
                  }, "Read More")
                ]),
                _createVNode(_Transition, {
                  "enter-active-class": "transition ease-out duration-100",
                  "enter-from-class": "transform opacity-0 scale-95",
                  "enter-to-class": "transform opacity-100 scale-100",
                  "leave-active-class": "transition ease-in duration-75",
                  "leave-from-class": "transform opacity-100 scale-100",
                  "leave-to-class": "transform opacity-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    (_ctx.isAboutDropDown)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, " It is a game-changer for seamless blockchaining of games and is a cost-less alternative to other app stores. Gamers can enjoy this fun and immersive gaming experience by either playing on or downloading blockchain games from Xarcade. At present, you can release a game in the " + _toDisplayString(_ctx.testnetLabel) + " environment which means that the tokens in your game have no real-world value in order for you to have your game tested by your contacts before its release. ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_99, [
            _hoisted_100,
            _createElementVNode("div", _hoisted_101, [
              _hoisted_102,
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("p", _hoisted_104, " By playing the Xarcade " + _toDisplayString(_ctx.mainnetLabel) + " games which are play-to-earn, they can create another income stream for themselves by collecting tokens which can be converted into real-world currencies.", 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}